// Utility functions for favicon badge management

let originalFavicon: string | null = null;

// Store the original favicon URL
export const storeOriginalFavicon = () => {
  const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
  if (favicon) {
    originalFavicon = favicon.href;
  }
};

// Update favicon with badge showing unread count
export const updateFaviconBadge = (unreadCount: number) => {
  if (unreadCount === 0) {
    // Restore original favicon
    restoreOriginalFavicon();
    return;
  }

  // Create canvas to draw badge
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  // Set canvas size (128x128 for maximum visibility)
  canvas.width = 128;
  canvas.height = 128;

  // Load original favicon image
  const img = new Image();
  img.crossOrigin = 'anonymous';
  
  img.onload = () => {
    // Draw original favicon scaled up
    ctx.drawImage(img, 0, 0, 128, 128);
    
    // Draw red circle for badge (much bigger and more visible)
    const badgeSize = 48;
    const badgeX = 128 - badgeSize - 8;
    const badgeY = 8;
    
    ctx.fillStyle = '#dc2626'; // red-600
    ctx.beginPath();
    ctx.arc(badgeX + badgeSize/2, badgeY + badgeSize/2, badgeSize/2, 0, 2 * Math.PI);
    ctx.fill();
    
    // Draw white text for count (much bigger font)
    ctx.fillStyle = 'white';
    ctx.font = 'bold 32px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    const countText = unreadCount > 9 ? '9+' : unreadCount.toString();
    ctx.fillText(countText, badgeX + badgeSize/2, badgeY + badgeSize/2);
    
    // Update favicon
    const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
    if (favicon) {
      favicon.href = canvas.toDataURL('image/png');
    }
  };
  
  img.onerror = () => {
    // If original favicon fails to load, create a simple badge
    createSimpleBadge(unreadCount);
  };
  
  // Use original favicon or default
  img.src = originalFavicon || '/favicon.ico';
};

// Create a simple badge without original favicon
const createSimpleBadge = (unreadCount: number) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  canvas.width = 128;
  canvas.height = 128;

  // Draw blue background
  ctx.fillStyle = '#2563eb'; // blue-600
  ctx.fillRect(0, 0, 128, 128);
  
  // Draw red circle for badge (much bigger and more visible)
  const badgeSize = 48;
  const badgeX = 128 - badgeSize - 8;
  const badgeY = 8;
  
  ctx.fillStyle = '#dc2626'; // red-600
  ctx.beginPath();
  ctx.arc(badgeX + badgeSize/2, badgeY + badgeSize/2, badgeSize/2, 0, 2 * Math.PI);
  ctx.fill();
  
  // Draw white text for count (much bigger font)
  ctx.fillStyle = 'white';
  ctx.font = 'bold 32px Arial';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  
  const countText = unreadCount > 9 ? '9+' : unreadCount.toString();
  ctx.fillText(countText, badgeX + badgeSize/2, badgeY + badgeSize/2);
  
  // Update favicon
  const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
  if (favicon) {
    favicon.href = canvas.toDataURL('image/png');
  }
};

// Restore original favicon
export const restoreOriginalFavicon = () => {
  if (originalFavicon) {
    const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
    if (favicon) {
      favicon.href = originalFavicon;
    }
  }
};
